/** True when the transcript translation failed and the entity fell back to the
 *  original transcript (subtitles and titles are in the audio language). */
export function shouldShowTranslationFailed(
  entity: { translation_status?: string | null } | null | undefined,
): boolean {
  return entity?.translation_status === 'failed';
}
